<div class="input-block">
    <div class="title"><strong>{{ title }}</strong>
        <employee-info-hint *ngIf="infoText" [infoText]="infoText"></employee-info-hint>
    </div>
    <textarea
        [class.invalid]="invalid && touched"
        [(ngModel)]="value"
        (input)="inputHandler($event)"
        [placeholder]="placeholder"
        [ngStyle]="{height: textHeight+'px'}"
        [maxlength]="maxLength"></textarea>
    <div class="limit-info"> {{ currentCharCount }}/{{ maxLength }} character limit</div>
    <div class="error-message">
        <span *ngIf="!value">Required</span>
    </div>
</div>
